import { AnuncioChip } from '../../anuncio/models/anuncio-chip.model';

export class FiltroBloqueioUsuarioPrivado {
  tipoPesquisa: string;
  cpf: string;
  nome: string;
  cnpj: string;
  razaoSocial: string;
}
